module.exports = "./img/ebbad96e19e44e232d66869e87fe6ff8.jpg";